import React, { useEffect, useState } from 'react';

export default function PageLoader({ pageKey }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    const timer = window.setTimeout(() => setVisible(false), 450);

    return () => window.clearTimeout(timer);
  }, [pageKey]);

  if (!visible) return null;

  return (
    <div className="preloader" role="status" aria-label="Loading">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
